import { processTypeEnum } from "../../Dashboard/Components/Clients/Common/Resource/Contents";
import { ProcessType } from "../IST/Resource/Content";

export class RestrictionHelper {
    static shouldHandleRestriction = (processType: ProcessType | processTypeEnum): boolean => {
        switch (processType) {
            case ProcessType.Quote:
            case processTypeEnum.Quote:
                return false;
            case ProcessType.NB:
            case ProcessType.NBEC:
            case processTypeEnum.NewBusiness:
            case processTypeEnum.NewBusinessExistingClient:
            case processTypeEnum.SinglePaymentTransfer:
            case processTypeEnum.RegularPayment:
                return true;
            default:
                return false;
        }
    };
}
